module.exports = __webpack_public_path__ + "img/ssa-logo.a119afaa.png";